export default "__VITE_ASSET__4d69f10c__"